import { useSyncExternalStore } from 'react'

/**
 * Browser pathname for hooks that run above `<RouterProvider>` (no `useLocation`).
 * Subscribes only to `popstate` (back/forward). Same-document navigations via
 * history.push/replace elsewhere do not re-render ancestors; crossing org/context
 * is expected to use a full navigation (`window.location` / reload).
 */
function subscribe(listener: () => void) {
    window.addEventListener('popstate', listener)
    return () => window.removeEventListener('popstate', listener)
}

function getSnapshot() {
    return window.location.pathname
}

export function useWindowPathname(): string {
    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
